import { types } from './definitions';

export default function useScroll(): types.UseScrollResults {
  const scrollTo = (scrollToOptions: ScrollToOptions): void => {
    const scrollContainer = document.querySelector(
      'div[class*="paste-theme-provider"]',
    );

    scrollContainer?.scrollTo(scrollToOptions);
  };

  return {
    scrollTo
  }
}
